import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';

@Component({
  selector: 'app-select-button-documents',
  templateUrl: './select-button-documents.component.html',
  styleUrls: ['./select-button-documents.component.css']
})
export class SelectButtonDocumentsComponent implements OnInit
{

  @Input()
  showDiv: string = 'certificates';

  @Input()
  lang: string = 'en'

  @Output()
  changeSelect = new EventEmitter<string>()

  stateOptions: any[] = [];

  constructor(
  )
  {

  }

  ngOnInit(): void {

    if(this.lang == 'es')
    {
      this.stateOptions = [
        { label: 'Certificados',
          value: 'certificates'
        },
        {
        label: 'Due diligence',
        value: 'technical_documentation' }
      ]
    }else{
      this.stateOptions = [
        { label: 'Certifications',
          value: 'certificates'
        },
        {
        label: 'Due diligence',
        value: 'technical_documentation' }
      ]
    }
  }

  changeSelection()
  {
    this.changeSelect.emit(this.showDiv);
  }

}
